<template>
  <v-card-text class="d-flex flex-column justify-space-around align-center metrics-card-text">
    <div class="d-flex flex-column align-center">
      <p class="text--primary">Chat System Rating</p>
      <p>(Last updated: {{ chatSystemScore.data.dateTime | formatDate }})</p>
    </div>
    <v-progress-circular v-if="loading" indeterminate size="64" />
    <template v-if="loaded">
      <template v-if="!chatSystemScore.data.codeWorking">
        <v-alert type="error" prominent>
          Code not working
        </v-alert>
      </template>
      <template v-else>
        <health-score-icon :satisfaction-level="chatSystemScore.data.score" />
        <system-score-description />
      </template>
    </template>
    <v-alert v-if="failed" type="warning" outlined>
      No system rating available.
    </v-alert>
  </v-card-text>
</template>

<script>
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import HealthScoreIcon from "@/components/HealthScore/CustomerOverview/HealthScoreIcon.vue";
import SystemScoreDescription from "@/components/HealthScore/CustomerOverview/SystemScoreDescription.vue";
import {dateToTimeDateString} from "@/helpers/dateHelper";

export default {
  name: "ChatSystemScore",
  components: {SystemScoreDescription, HealthScoreIcon},
  computed: {
    ...mapState('healthScoreStore', ['chatSystemScore']),
    loading() {
      return this.chatSystemScore.state === LoadingState.LOADING;
    },
    loaded() {
      return this.chatSystemScore.state === LoadingState.LOADED;
    },
    failed() {
      return this.chatSystemScore.state === LoadingState.FAILED;
    },
  },
  filters: {
    formatDate: function (value) {
      return dateToTimeDateString(value);
    }
  },
}
</script>

<style scoped>

</style>